<template>
  <div class="popup-overlay" @click="handleCancel">
    <div class="popup-container" @click.stop>
      <h2 class="popup-title">{{ title }}</h2>

      <p class="popup-subtitle">{{ subtitle }}</p>

      <textarea
        v-model="inputValue"
        class="popup-input"
        :placeholder="inputPlaceholder"
        :maxlength="charLimit"
        rows="4"
      />

      <div class="char-counter" :class="{ 'limit-reached': inputValue.length === charLimit }">
        {{ inputValue.length }}/{{ charLimit }}
        <span v-if="inputValue.length === charLimit" class="limit-message"> - No more space</span>
      </div>

      <div class="popup-buttons">
        <button class="popup-button submit-button" @click="handleSubmit">
          {{ submitButtonText }}
        </button>
        <button class="popup-button cancel-button" @click="handleCancel">
          {{ cancelButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  title: String,
  subtitle: String,
  inputPlaceholder: {
    type: String,
    default: 'Enter text',
  },
  submitButtonText: {
    type: String,
    default: 'Submit',
  },
  cancelButtonText: {
    type: String,
    default: 'Cancel',
  },
  charLimit: {
    type: Number,
    default: 100,
  },
});

const emit = defineEmits(['submit', 'cancel']);

const inputValue = ref('');

const handleSubmit = () => {
  if (inputValue.value.trim()) {
    emit('submit', inputValue.value.trim());
    inputValue.value = '';
  }
};

const handleCancel = () => {
  emit('cancel');
  inputValue.value = '';
};
</script>

<style lang="scss" scoped>
@import '../../../../scss/riseup-vars';

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-container {
  width: 348px;
  height: 441px;
  background-color: white;
  border-radius: 36px;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
}

.popup-title {
  font-family: 'Qanelas Soft', 'SalaryFinance', sans-serif;
  font-size: 36px;
  font-weight: 500;
  line-height: 1.07;
  letter-spacing: -0.01em;
  color: #002579;
  margin: 0 0 16px 0;
}

.popup-subtitle {
  font-family: 'SalaryFinance', sans-serif;
  font-size: 16px;
  color: #373530;
  margin: 0 0 24px 0;
}

.popup-input {
  padding: 12px 16px;
  border: 2px solid #dddddd;
  border-radius: 12px;
  font-family: 'SalaryFinance', sans-serif;
  font-size: 16px;
  margin-bottom: 24px;
  box-sizing: border-box;
}

.popup-input:focus {
  outline: none;
  border-color: #002579;
}

.char-counter {
  font-family: 'SalaryFinance', sans-serif;
  font-size: 12px;
  color: #888888;
  margin-bottom: 12px;
  text-align: right;
}

.char-counter.limit-reached {
  color: #fd5f5a;
  font-weight: 600;
  text-align: start;
}

.limit-message {
  margin-left: 4px;
}

.popup-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
}

.popup-button {
  flex: 1;
  padding: 14px 16px;
  border: none;
  border-radius: 12px;
  font-family: 'SalaryFinance', sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.cancel-button {
  background-color: #f0f0f0;
  color: #373530;
}

.submit-button {
  background-color: #002579;
  color: white;
}
</style>
